import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'
// import useBreakpoint from '@utils/useBreakpoints'

import { manifestationDate, manifestationHasActions } from '@screens/manifestations/manifestationsUtils'

interface Props {
  manifestation: ManifestationResponse
  onClick: () => void
}

const ManifestationListCard = ({ manifestation, onClick }: Props) => {
  const i18n = useI18n()
  // const [, currentBreakpoint] = useBreakpoint()
  // const isPhone = currentBreakpoint === 'phone'

  const hasActions = manifestationHasActions(manifestation)

  return (
    <Container key={manifestation.id} activeOpacity={0.9} onPress={onClick}>
      <SafeContainer>
        <TopContainer>
          <Infos>
            <Name numberOfLines={2} ellipsizeMode="tail">
              {manifestation.libelle}
            </Name>
            <EventDate>{manifestationDate(manifestation, i18n)}</EventDate>
          </Infos>
          <IconContainer>
            <Icon name={hasActions ? 'problem' : 'arrow'} size={24} color={theme.colors.primary} />
          </IconContainer>
        </TopContainer>
        {/*
        TODO : not implemented
        !over && manifestation.incidentsTotal !== undefined && (
          <BottomContainer>
            <IncidentTotal>
              <IncidentIndicator>
                <IncidentIndicatorTotal>{manifestation.incidentsTotal}</IncidentIndicatorTotal>
              </IncidentIndicator>
              {!isPhone && (
                <IncidentLabel>
                  {i18n.t('screens.site.incidentsInProgress', { count: manifestation.incidentsTotal })}
                </IncidentLabel>
              )}
            </IncidentTotal>
            {isPhone && (
              <IconContainer>
                <Icon name="arrow" size={24} color={theme.colors.primary} />
              </IconContainer>
            )}
          </BottomContainer>
        )
        */}
      </SafeContainer>
    </Container>
  )
}

export default ManifestationListCard

const Container = styled(TouchableOpacity)`
  border-radius: 8px;
  background-color: white;
  ${(props) => props.theme.breakpoint !== 'phone' && `width:360px;`}
  ${(props) => props.theme.constants.shadow}
`
const SafeContainer = styled(View)`
  border-radius: 8px;
  overflow: hidden;
  flex-direction: ${(props) => (props.theme.breakpoint === 'phone' ? 'row' : 'column')};
  ${(props) => props.theme.breakpoint === 'phone' && `align-items: center;`}
`
const TopContainer = styled(View)`
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? '16px' : '16px 24px')};
  background-color: ${(props) => props.theme.colors.background};
  flex-direction: row;
  align-items: center;
  ${(props) => props.theme.breakpoint === 'phone' && `flex: 1;`}
`

const Name = styled(Text)<{ isList?: boolean }>`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Body : props.theme.fonts.Headline)};
  ${(props) => props.theme.breakpoint === 'phone' && `margin-bottom: 4px;`}
`
const EventDate = styled(Text)<{ isList?: boolean }>`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => props.theme.colors.secondaryText};
`
const IconContainer = styled(View)`
  margin: 0 8px 0 16px;
`
const Infos = styled(View)`
  flex: 1;
`
